



































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import UserPhoneEditForm from '@/modules/user/components/shared/phone-verification/UserPhoneEditForm.vue'
import AlertNotification from '@/modules/notification/components/panel/AlertNotification.vue'
import UserPhoneVerifyForm from '@/modules/user/components/shared/phone-verification/UserPhoneVerifyForm.vue'
import { AuthService } from '@/modules/user/services/auth.service'
import CountDownStore from '@/modules/common/coutn-down/store/countDown.store'
import QForm from 'quasar/src/components/form/QForm.js';
import { Prop, Watch } from 'vue-property-decorator'
import { UserSendPhoneVerificationRequestModel } from '@/modules/user/models/user-request.model'

@Component({
  components: { UserPhoneVerifyForm, AlertNotification, UserPhoneEditForm, Modal, BaseButton }
})
export default class UserPhoneVerifyButton extends Vue {

  constructor(
    private readonly service: AuthService,
    private readonly countDownStore: CountDownStore
  ) {
    super()
  }

  $refs!: {
    nameUpdateForm: QForm,
  }

  @Prop({ default: false }) value!: boolean
  @Prop({ default: null }) phone!: string
  @Prop() isVerified!: boolean

  phoneNumber = this.phone

  editPhoneModal = false
  verifyPhoneModal = false

  verifyLoading = false
  resendLoading = false
  editLoading = false

  verifyTimeOut = false
  timerDuration = 60

  //Hooks
  updated() {
    this.$emit('showDialog', this.editPhoneModal || this.verifyPhoneModal)
  }

  //Computed
  get phoneModal() {
    return this.editPhoneModal
  }

  set phoneModal(value) {
    this.editPhoneModal = value
    this.$emit('input', value)
  }

  //Watch
  @Watch('value')
  onValueChange(newVal) {
    this.phoneModal = newVal
  }

  //Methods
  verifyPhoneVerification() {
    if (this.countDownStore.seconds > 0 && this.countDownStore.seconds < this.timerDuration) {
      this.verifyPhoneModal = true
      this.verifyLoading = false
    } else {
      this.verifyLoading = true
      this.service.resendVerificationSmsCode(
        { phone: this.phoneNumber } as UserSendPhoneVerificationRequestModel
      ).then(() => {
        this.verifyLoading = false
        this.verifyPhoneModal = true
        this.verifyTimeOut = false
        this.countDownStore.resetTimer(this.timerDuration)
      }).catch(() => {
        this.verifyLoading = false
      })
    }
  }

  onEdited(event) {
    if (event) {
      this.countDownStore.resetTimer(this.timerDuration)
      this.editPhoneModal = false
      this.verifyPhoneModal = true
    }
  }

  onVerified(event) {
    if (event) this.verifyPhoneModal = false
  }

  onResend(event) {
    if (event) {
      this.countDownStore.resetTimer(this.timerDuration)
      this.countDownStore.setTimer()
    }
  }

  onPhoneEdit() {
    this.editPhoneModal = true
    this.verifyPhoneModal = false
    this.verifyTimeOut = false
  }

}
